require('jquery-ui/ui/keycode');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/datepicker.css');


//////////////////
// WEBPACK FOOTER
// (webpack)-jquery-ui/datepicker.js
// module id = 154
// module chunks = 1 2 4 5